import { useFormContext } from '@/contexts/form-context';
import NumberInput from './number-input';

interface NumberFormInputProps {
  name: string;
  label: string;
}

export default function NumberFormInput({ name, label }: NumberFormInputProps) {
  const form = useFormContext();

  return (
    <form.Field
      name={name}
      children={(field) => (
        <NumberInput onChange={field.handleChange} value={field.state.value as number} label={label} />
      )}
    />
  );
}
